const styleSheet = {
  container: {
    maxWidth: "601px",
    margin: "0 auto"
  },
  error: {
    color: "#FF6969",
    fontSize: "12px",
    letterSpacing: 0,
    paddingLeft: "10px",
    marginTop: "5px"
  },
  input: {
    boxSizing: "border-box",
    height: "60px",
    width: "100%",
    border: "1.2px solid #D8DCE6",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    color: "#051D39",
    fontSize: "14px",
    padding: "0 25px",
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "#B7C1E1"
    },
    "&:-ms-input-placeholder": {
      textOverflow: "ellipsis !important",
      color: "#B7C1E1"
    },
    "&:-webkit-input-placeholder": {
      textOverflow: "ellipsis !important",
      color: "#B7C1E1"
    }
  },
  controls: {
    marginTop: "48px",
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginRight: "16px"
    },
    "& :last-child": {
      marginRight: 0
    }
  },
  alerts: {
    marginTop: "30px"
  },
  alertOptions: {
    animation: "0.5s fadeIn",
    marginTop: "15px",
    paddingLeft: "27px"
  },
  checkBoxRow: {
    margin: "15px 0",
    display: "flex",
    "& span": {
      paddingLeft: "10px",
      color: "#085FE5",
      fontSize: "12px"
    }
  },
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
};

export default styleSheet;
